import React from 'react';
import './separator.scss';
import SeparatorImage from "../../assets/separator.png";

function Separator() {
    return(   
        <img className='separator' src={SeparatorImage}></img>
    );
}
export default Separator;